export default "__VITE_ASSET__6d2fc772__"